module.exports = __webpack_public_path__ + "static/media/cs-steps.73d75fd4.png";